import { render } from "./Subjects.vue?vue&type=template&id=24507acc"
import script from "./Subjects.vue?vue&type=script&lang=js"
export * from "./Subjects.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__